module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/apple-watch-e70a30be00a566fc70dcf89c189f1306.svg";